import { Field } from "formik"
import { Button, FloatingLabel, Form, InputGroup } from "react-bootstrap"
import { checkVal } from "../../../Helpers/Parsers/checkVal"
import { useState } from "react"
import { Eye, EyeFill } from "react-bootstrap-icons"

export const PasswordInputField = (props: {
    fieldLabel: string,
    fieldName: string,
    placeholder: string,
    customClass?: string,
    required?: boolean,
    disabled?: boolean,
    errors?: any,
    touched?: any,
    fieldType?: string,
    subText?: string,
    onKeyDown?: (e: any) => void,
    onChange?: (e: any) => void,
    extra?: any,
}) => {

    const [showPassword, setShowPassword] = useState(false)

    const {
        fieldLabel,
        fieldName,
        placeholder,
        customClass,
        fieldType,
        required,
        subText,
        disabled,
        onChange,
        onKeyDown,
        // extra = {},
    } = props
    return (
        <>
            <Field name={fieldName} >
                {({
                    field: { value },
                    form
                }: any) => (
                    <Form.Group className={`mb-3 ${customClass ? customClass : ''}`}>
                        {/* <Form.Label>{fieldLabel}{required ? '*' : ''}</Form.Label> */}
                        <InputGroup>
                            <FloatingLabel
                                style={{ flex: 1 }}
                                controlId={fieldName}
                                label={`${fieldLabel}${required ? '*' : ''}`}>
                                <Form.Control
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder={placeholder}
                                    {...(fieldType === 'textarea' ? { as: 'textarea' } : {})}
                                    name={fieldName}
                                    required={required}
                                    disabled={disabled}
                                    size={'lg'}
                                    value={value || value === 0 ? value : fieldType === 'number' ? '' : ''}
                                    onKeyDown={(e: any) => {
                                        if (onKeyDown) {
                                            onKeyDown(e)
                                        }
                                    }}
                                    onChange={(e: any) => {
                                        if (onChange) {
                                            onChange(e)
                                        }
                                        form.handleChange(e)
                                    }}
                                    onBlur={form.handleBlur}
                                    isInvalid={checkVal(form.touched, fieldName) && checkVal(form.errors, fieldName)}
                                    isValid={!checkVal(form.errors, fieldName) && checkVal(form.touched, fieldName)}
                                    style={fieldType === 'textarea' ? { minHeight: '100px' } : {
                                        borderTopRightRadius: '0',
                                        borderBottomRightRadius: '0'
                                    }}
                                />

                            </FloatingLabel>
                            <Button
                                variant="outline-secondary"
                                onClick={() => {
                                    setShowPassword(!showPassword)
                                }}
                            >
                                {/* eye emoji */}
                                {showPassword ? (
                                    <Eye />
                                ) : (
                                    <EyeFill />
                                )}
                            </Button>
                        </InputGroup>

                        {subText && (
                            <Form.Text className="text-muted">
                                {subText}
                            </Form.Text>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {checkVal(form.errors, fieldName)}
                        </Form.Control.Feedback>
                    </Form.Group>
                )}
            </Field>

            {/*<div className={`field-container text-input-container ${customClass ? customClass : ''}`}>
      <label htmlFor={fieldLabel}>{fieldLabel}{required ? '*' : ''}</label><br />
      <Field
      className={`${checkVal(touched, fieldName) ? !checkVal(errors, fieldName) ? 'valid' : 'error' : ''}`}
      type={fieldType ? fieldType : "text" }
      placeholder={placeholder}
      name={fieldName} /><br />
      <ErrorMessage name={fieldName} render={ErrorComponent} />
    </div>*/}
        </>
    )
}
